import { Form } from "@repo/ui";
import { useForm } from "react-hook-form";
import FormInput from "ui/Input";

export default function LocationDetails({ location }) {
  const form = useForm({ defaultValues: { ...location } });

  const generalProps = {
    errors: form.formState.errors,
    control: form.control,
  };

  const usingCustomerWindow = location?.followsCustomerServiceWindow === true;

  const formatTime = (time) => {
    if (!time) return "-";
    return time.slice(0, 5);
  };

  const formatRange = (start, end) => {
    if (!start || !end) return "-";
    return `${formatTime(start)} - ${formatTime(end)}`;
  };

  // Filter customer windows by matching city
  const filteredCustomerWindows = usingCustomerWindow
    ? location?.customerServiceWindows?.filter(
        (window) =>
          window?.city?.toLowerCase() === location?.city?.toLowerCase(),
      ) || []
    : [];

  const hasServiceWindows =
    !usingCustomerWindow && location?.serviceWindows?.length > 0;

  const hasCustomerWindows =
    usingCustomerWindow && filteredCustomerWindows.length > 0;

  return (
    <div
      className="form-container overflow-y-auto"
      style={{
        margin: 0,
        maxHeight: "80vh",
      }}
    >
      <Form {...form}>
        <form className="custom-form-v2">
          <h1 className="text-lg font-medium">Asset Details</h1>

          <div className="dialogue-form-row mt-4">
            <FormInput
              {...generalProps}
              name="locationId"
              label="Asset ID"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="barcode"
              label="Barcode"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="locationName"
              label="Location Name"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="emirate"
              label="Emirate"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="state"
              label="Region"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="machineType"
              label="Machine Type"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="customer"
              label="Customer"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="maker"
              label="Maker"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="address"
              label="Address"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            {/* SERVICE ACCESS TIMINGS */}
            {hasServiceWindows || usingCustomerWindow ? (
              <div className="col-span-full mt-4">
                <div className="flex items-center justify-between mb-2">
                  <h2 className="text-md font-medium">
                    Service Access Timings
                  </h2>

                  <label className="flex items-center gap-2 text-sm cursor-default">
                    <h2 className="text-md font-medium">
                      Follows Customer Timing
                    </h2>
                    <input
                      type="checkbox"
                      checked={usingCustomerWindow}
                      disabled
                      className="cursor-not-allowed"
                    />
                  </label>
                </div>

                {/* SERVICE WINDOWS TABLE */}
                {hasServiceWindows ? (
                  <div className="overflow-x-auto border rounded">
                    <table className="w-full text-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="text-left px-3 py-2">Day</th>
                          <th className="text-left px-3 py-2">Primary Time</th>
                          <th className="text-left px-3 py-2">
                            Secondary Time
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {location.serviceWindows.map((window) => (
                          <tr key={window.dayOfWeek} className="border-t">
                            <td className="px-3 py-2 font-medium">
                              {window.dayOfWeek}
                            </td>

                            <td className="px-3 py-2">
                              {formatRange(window.startTime, window.endTime)}
                            </td>

                            <td className="px-3 py-2">
                              {formatRange(
                                window.secondStartTime,
                                window.secondEndTime,
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : null}

                {/* CUSTOMER SERVICE WINDOWS (Filtered by City) */}
                {usingCustomerWindow ? (
                  <>
                    {hasCustomerWindows ? (
                      <div className="grid grid-cols-2 gap-2">
                        {filteredCustomerWindows.map((window, index) => (
                          <div
                            key={index}
                            className="border rounded px-3 py-2 space-y-1"
                          >
                            <div className="font-medium">
                              {window.activityType}
                            </div>

                            <div className="text-xs text-gray-500">
                              {window.city} • {window.serviceType}
                            </div>

                            <div className="text-sm border rounded px-2 py-1 inline-block">
                              {formatRange(window.startTime, window.endTime)}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="border rounded px-3 py-3 text-sm text-gray-500">
                        No service timing available for this city.
                      </div>
                    )}
                  </>
                ) : null}
              </div>
            ) : null}
          </div>
        </form>
      </Form>
    </div>
  );
}
